import type { ReactNode } from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** `'row'` = tek `<TableCell colSpan>` ortalı metin (tablo gövdesi içinde). */
  variant?: 'block' | 'row';
  colSpan?: number;
}

/** Boş-durum göstergesi — liste tablolarındaki kopyalanan
 *  `<TableRow><TableCell colSpan><Typography py:2 textAlign:center>` üçlüsünü ve
 *  kart/panel içi boş durumları tek yerde toplar. */
export function EmptyState({ icon, title, description, action, variant = 'block', colSpan = 1 }: EmptyStateProps) {
  const body = (
    <Box sx={{ textAlign: 'center', py: variant === 'row' ? 2 : 5, px: 2 }}>
      {icon && (
        <Box sx={{ color: 'text.disabled', mb: 1, '& svg': { fontSize: 40 } }}>{icon}</Box>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: variant === 'block' ? 600 : 400 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );

  if (variant === 'row') {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} sx={{ borderBottom: 'none' }}>
          {body}
        </TableCell>
      </TableRow>
    );
  }
  return body;
}
